import React from 'react';
import {Body} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import type {CampaignProps} from '@/types/campaign';
import BriefSection from '../../shared/BriefSection';

interface TimelineOverviewProps {
  campaign: CampaignProps;
}

function TimelineOverview({campaign}: TimelineOverviewProps) {
  const {daysToPostAfterDeliverableFulfilled} = campaign;
  if (!daysToPostAfterDeliverableFulfilled) {
    return null;
  }
  return (
    <BriefSection title={translate('Timeline overview')}>
      <Body size="md">
        {translate('materials-should-be-submitted', {
          count: daysToPostAfterDeliverableFulfilled,
        })}
      </Body>
    </BriefSection>
  );
}

export default TimelineOverview;
